module.exports = __webpack_public_path__ + "img/people.febc3227.svg";